import { staticPath } from  '@/utils/baseUrl.js'
// import Home from './pages/wx/home/home.vue'
import Home from './pages/home/commonHome.vue'
import BasicInfo from './pages/ks/shopManagement/basicInfo.vue'
import Order from './pages/wx/profit/order.vue'
import Marketing from './pages/ks/marketing/marketing.vue'
import CreateMarket from './pages/ks/marketing/createMarket.vue'
import GettingUserInformation from './pages/gettingUserInformation/gettingUserInformation.vue'
// import SmallsSoreCourses from './pages/wx/course/list.vue'
// import AddSmallCourse from './pages/wx/course/addCourse.vue'

export const list =  {
        path: staticPath + 'home',
        component:Home,
        children:[
        {
            path: staticPath + 'basicInfo', // 基本信息
            component: BasicInfo,
            meta: {
                id: 3, 
                title: '基本信息',
                pathName: staticPath + 'basicInfo'
            }
        },
        {
            path: staticPath + 'order', //  订单统计
            component:Order,
            meta: {
                id: 9,
                title: '订单统计',
                pathName: staticPath + 'order'
            }
        },
        {
            path: staticPath + 'marketing',
            component: Marketing,
            meta: {
                id: 15,
                title: '抢购活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path: staticPath + 'createMarket',
            component: CreateMarket,
            meta: {
                title: '添加活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path: staticPath + 'gettingUserInformation',
            name: 'GettingUserInformation',
            component: GettingUserInformation,
            meta: {
                title: '用户信息获取',
                id: 22,
                pathName: staticPath + 'gettingUserInformation'
            }
        },
        // {
        //     path: staticPath + 'smallsSoreCourses',
        //     name: 'SmallsSoreCourses',
        //     component: SmallsSoreCourses,
        //     meta: {
        //         title: '小店课程',
        //         pathName: staticPath + 'smallsSoreCourses'
        //     }
        // },
        // {
        //     path: staticPath + 'addSmallCourse',
        //     name: 'AddSmallCourse',
        //     component: AddSmallCourse,
        //     meta: {
        //         title: '添加课程',
        //         pathName: staticPath + 'smallsSoreCourses'
        //     }
        // },
        // {
        //     path: staticPath + 'editSmallCourse/:id', // 修改课程
        //     component: AddSmallCourse,
        //     name: 'editSmallCourse',
        //     meta: {
        //         // id: 223,
        //         title: '编辑课程',
        //         pathName: staticPath + 'smallsSoreCourses'
        //     }
        // },
       
    ]
}


export const wxList = list
